export{Carousel,CarouselScrollbar,CarouselScrubber}from"@vds-core/carousels";
